export default "__VITE_PUBLIC_ASSET__837f6ff4__"